var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileappInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.703,
    height: 42.724,
    viewBox: "0 0 26.703 42.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(-1124 -811.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M28.112,2.67H12.091a2.67,2.67,0,0,0-2.67,2.67V37.384a2.67,2.67,0,0,0,2.67,2.67H28.112a2.67,2.67,0,0,0,2.67-2.67V5.341A2.67,2.67,0,0,0,28.112,2.67ZM12.091,0A5.341,5.341,0,0,0,6.75,5.341V37.384a5.341,5.341,0,0,0,5.341,5.341H28.112a5.341,5.341,0,0,0,5.341-5.341V5.341A5.341,5.341,0,0,0,28.112,0Z",
    transform: "translate(1117.25 811.276)",
    fill: "#857f7b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M18.42,32.341a2.67,2.67,0,1,0-2.67-2.67A2.67,2.67,0,0,0,18.42,32.341Z",
    transform: "translate(1118.931 816.319)",
    fill: "#575651",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 19,
    height: 6,
    rx: 1,
    transform: "translate(1128 818)",
    fill: "#de996f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileappInactive);
export default __webpack_public_path__ + "static/media/mobileapp-inactive.1c0b2759e45ec72406c0eb05bb2a4c82.svg";
export { ForwardRef as ReactComponent };